import { render, staticRenderFns } from "./vnus.vue?vue&type=template&id=a3fc362c&"
import script from "./vnus.vue?vue&type=script&lang=js&"
export * from "./vnus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports